module.exports = __webpack_public_path__ + "img/search-white.a9964b47.svg";